import React from 'react';
import AppShell from '@/components/layout/AppShell';
import { kasirNav } from '@/lib/navConfig';
import CustomersManager from '@/components/customers/CustomersManager';

export default function KasirCustomers() {
  return (
    <AppShell nav={kasirNav} title="Daftar Customer">
      <CustomersManager />
    </AppShell>
  );
}
